import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';

// MODULES
import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { ClientShippingAddressAccessorComponent } from '../client/components/client-shipping-address-accessor/client-shipping-address-accessor.component';
import { ClientShippingAddressOverridePipe } from '../client/pipes/client-shipping-address-override.pipe';
import { ClientProfileModule } from '../client-profile/client-profile.module';
import { CustomFieldModule } from '../custom-field/custom-field.module';
import { PackageModule } from '../package/package.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

import { FilterModule } from './../filter/filter.module';
import { RfqModule } from './../rfq/rfq.module';
import { DirectiveModule } from './../shared/directives/directive.module';

// PIPES

import {
  InvoiceCreateComponent,
  InvoiceNoteFormComponent,
  InvoiceAdvanceSettingsFormComponent,
  InvoiceClientComponent,
  InvoiceClientFormComponent,
  InvoiceSkusComponent,
  InvoiceSkusTableComponent,
  InvoiceSkuPriceFormComponent,
  InvoiceSkuDiscountAmountFormComponent,
  InvoiceSkuDiscountPercentFormComponent,
  InvoicePackageDropdownComponent,
} from './components';

const components = [
  InvoiceCreateComponent,
  InvoiceNoteFormComponent,
  InvoiceAdvanceSettingsFormComponent,
  InvoiceClientComponent,
  InvoiceClientFormComponent,
  InvoiceSkusComponent,
  InvoiceSkusTableComponent,
  InvoiceSkuPriceFormComponent,
  InvoiceSkuDiscountAmountFormComponent,
  InvoiceSkuDiscountPercentFormComponent,
  InvoicePackageDropdownComponent,
];

const standaloneComponents = [ClientShippingAddressAccessorComponent];
const standalonePipes = [ClientShippingAddressOverridePipe]

const angularModules = [
  ClipboardModule,
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
];
const lumModules = [
  ClientProfileModule,
  MaterialCustomModule,
  SharedComponentsModule,
  PipeModule,
  FeatureModule,
  FilterModule,
  RfqModule,
  UiModule,
  DirectiveModule,
  CustomFieldModule,
  PackageModule,
];
@NgModule({
  declarations: [...components],
  imports: [
    ...angularModules,
    ...lumModules,
    ...standaloneComponents,
    ...standalonePipes,
    NgxPermissionsModule,
  ],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class InvoiceModule {}
